import React from 'react'
import PropTypes from 'prop-types'

import useStyle from 'shared/hooks/useStyle'
import SummaryChoicesItem from './SummaryChoicesItem'

import styles from './SummaryChoicesList.style'

const propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        choiceLabel: PropTypes.string.isRequired,
        choiceIdentifier: PropTypes.string.isRequired,
    })).isRequired,
    choice: PropTypes.string.isRequired,
    isAnswered: PropTypes.bool,
    children: PropTypes.node,
}

const SummaryChoicesList = ({
    items,
    choice,
    isAnswered = false,
    children,
}) => {
    const classes = useStyle(styles)

    return (
        <div css={classes.summaryView}>
            {items.map((item) => {
                return (
                    <div key={`list-${item.choiceIdentifier}`}>
                        <SummaryChoicesItem
                            choice={choice}
                            choiceLabel={item.choiceLabel}
                            choiceIdentifier={item.choiceIdentifier}
                            isAnswered={isAnswered}
                        />
                        {choice === item.choiceIdentifier && children}
                    </div>
                )
            })}
        </div>
    )
}

SummaryChoicesList.propTypes = propTypes

export default SummaryChoicesList
